import clsx from 'clsx';
import { CrossIcon } from 'components/Icon';
import styles from './CloseButton.css';

interface CloseButtonProps {
	testId: string;
	rootClass?: string;
	iconClass?: string;
	onClick: () => void;
}

export function CloseButton(props: Readonly<CloseButtonProps>) {
	const { rootClass, onClick, testId } = props;

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		onClick();
	};

	return (
		<button data-testid={testId} className={clsx(styles.root, rootClass)} onClick={handleClick}>
			<CrossIcon className={props.iconClass} />
		</button>
	);
}
